import clsx from 'clsx';
import { ReactComponent as TrustedShopLogo } from '../assets/trusted-shop-logo.svg';
import { TRUSTED_SHOPS_FEEDBACK_URL } from '../config';
import { TrustedShopsStarRating } from '../TrustedShopsStarRating/TrustedShopsStarRating';
import { getTextGrade } from '../utils';
import styles from './TrustedShopsSimpleRating.module.scss';
import { TrustedShopsSimpleRatingProps } from './types';

const TrustedShopsSimpleRating = ({
  rating,
  className,
  color = 'default',
}: TrustedShopsSimpleRatingProps) => {
  const formattedRating = rating.toFixed(2).replace('.', ',');
  const textGrade = getTextGrade(rating);

  return (
    <a
      href={TRUSTED_SHOPS_FEEDBACK_URL}
      target="_blank"
      rel="noopener noreferrer"
      title="Zur Bewertungsseite von Trusted Shops"
      className={clsx(styles.container, styles[color], className)}
    >
      <TrustedShopLogo className={styles.logo} aria-hidden />

      <span className="visually-hidden">Trusted Shops Bewertung:</span>
      <span className={styles.text}>
        <span className={styles.ratingValue}>{formattedRating}</span>/5{' '}
        {textGrade}
      </span>

      <span className={styles.stars} aria-hidden>
        <TrustedShopsStarRating rating={rating} color={color} />
      </span>
    </a>
  );
};

export default TrustedShopsSimpleRating;
